<div class="job-type-switcher" *ngIf="currentUser">

    <!-- Loading state -->
    <div *ngIf="isLoading" class="function-loading d-flex align-items-center">
        <mat-spinner diameter="16"></mat-spinner>
        <span class="loading-text ms-2">Se încarcă...</span>
    </div>

    <!-- Function display with horizontal layout -->
    <div *ngIf="!isLoading && activeFunction"
        class="function-container d-flex flex-row align-items-center justify-content-between gap-3">
        <!-- Active function display -->
        <!-- <div class="current-function d-flex align-items-center"
            [title]="'Funcția activă: ' + activeFunction.functie_name">
            <span class="function-name">{{ activeFunction.functie_name }}</span>
        </div> -->

        <!-- Manage functions button (only show if user has functions) -->
        <div *ngIf="userFunctions.length > 0" class="manage-section">
            <button class="manage-functions-btn d-flex align-items-center" (click)="onManageFunctions()"
                matTooltip="Gestionează funcțiile">
                <mat-icon class="me-1">settings</mat-icon>
                <!-- <span>Gestionează funcțiile</span> -->
                <span>{{ activeFunction.functie_name }}</span>
            </button>
        </div>
    </div>

    <!-- No functions warning -->
    <div *ngIf="shouldShowNoFunctionWarning()" class="no-function-warning">
        <div class="warning-content d-flex align-items-center" (click)="onManageFunctions()">
            <mat-icon class="warning-icon me-2">warning</mat-icon>
            <span class="warning-text me-2">Nicio funcție</span>
            <mat-icon class="settings-icon">settings</mat-icon>
        </div>
    </div>
</div>